import { gsap, TweenMax, TweenLite, ScrollTrigger } from 'gsap/all.js';
gsap.registerPlugin(ScrollTrigger, TweenMax, TweenLite);

// Trigger header on scroll
gsap.to('.menuDesktop', { 
  duration: 0.2,
  scrollTrigger: {
    start: 'top -80',
    end: 99999,
    toggleActions: 'play none none reverse',
    toggleClass: {className: 'scrolled', targets: 'header.wp-block-template-part'},
  },
});

// Search
var button = document.querySelector('div.search-icon');
var tween = TweenLite.from('.wp-block-search', 0.3, {y:-100, opacity:0});
var icon = TweenMax.set(button, { css:{ className:'search-icon active' } });
tween.reverse();
icon.reverse();
button.onclick = function() {
  tween.reversed(!tween.reversed());
  icon.reversed(!icon.reversed());
}

// Link to hash
var hash = window.location.hash;
if ($(hash).length) {
    $('html, body').animate({
        scrollTop: $(hash).offset().top + -220,
    }, 600);
}

$('a[href*="#"]')
.not('[href="#"]')
.not('[href="#0"]')
.click(function(event) {
  if (
    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
    && 
    location.hostname == this.hostname
  ) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    if (target.length) {
      event.preventDefault();
      $('html, body').animate({
        scrollTop: target.offset().top + -220,
      }, 600, function() {
        var $target = $(target);
        $target.focus();
        if ($target.is(':focus')) {
          return false;
        } else {
          $target.attr('tabindex','-1');
          $target.focus();
        }
      });
    }
  }
});

// Media-text block
gsap.utils.toArray('.wp-block-media-text').forEach(function(elem) {
  let figure= elem.querySelector('figure');
  let content = elem.querySelector('.wp-block-media-text__content');
  hide(figure);
  hide(content);
  ScrollTrigger.create({
    trigger: elem,
    once: true,
    start: 'top bottom-=100',
    onEnter: function() { animateFrom(elem) }, 
    onEnterBack: function() { animateFrom(elem, -1) },
  });
});

// Header + text
gsap.utils.toArray('.wp-block-cover').forEach(function(elem) {
  let figure= elem.querySelector('.wp-block-cover__image-background');
  let title = elem.querySelector('.wp-block-cover__inner-container h1');
  let text = elem.querySelector('.wp-block-cover__inner-container .wp-block-buttons');
  let tl = gsap.timeline({defaults: {ease: 'power4.inOut', duration: 1.5 }})
  tl.from(figure, { autoAlpha: 0, duration: 0.5, size: 100, ease: 'Expo.EaseOut'})
    .from(title, {autoAlpha: 0, y: 30}, '<')
    .from(text, {autoAlpha: 0, y: 30}, '<+=0.2')
  tl.pause();
  ScrollTrigger.create({
    trigger: elem,
    start: 'top bottom-=50%',
    onEnter: function() { tl.resume(); }, 
  });
});

// Animate functions
function animateFrom(elem, direction) {
  direction = direction | 1;
  var x = 0,
      y = direction * 0;
  if(elem.classList.contains('has-media-on-the-right')) {
    x = 0;
    y = 0;
  } else {
    x = 0;
    y = 0;
  }
  let figure= elem.querySelector('figure');
  gsap.fromTo(figure, {x: x, y: y, autoAlpha: 0}, {
    duration: 2.25, 
    x: 0,
    y: 0, 
    autoAlpha: 1, 
    ease: 'expo', 
    overwrite: 'auto',
  });
  let content = elem.querySelector('.wp-block-media-text__content');
  x = 0,
  y = direction * 0;
  gsap.fromTo(content, {x: x, y: y, autoAlpha: 0}, {
    duration: 2.25, 
    x: 0,
    y: 0, 
    autoAlpha: 1, 
    ease: 'expo', 
    overwrite: 'auto',
  });
}
function hide(elem) {
  gsap.set(elem, {autoAlpha: 0});
}
